import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["successMessage"]

  async submit(event) {
    event.preventDefault()
    const form = event.target
    const data = new FormData(form)

    try {
      await fetch(form.action, {
        method: "POST",
        body: data,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/html"
        }
      })
      // Rodauth redirects after success — regardless of response, show confirmation
      this.showSuccess()
    } catch (_e) {
      // On network error, fall back to normal form submission
      form.submit()
    }
  }

  showSuccess() {
    this.successMessageTarget.classList.remove("hidden")
  }
}
